import React from "react";
import './loadingView.css';
import logo from '../assets/logo.png'


function LoadingView(){

    return(
        <div className='main-content'>
          
            <img className="logo-loading" src={logo}/>
              <p>Loading</p>
        </div>

    )
}

export default LoadingView